import React from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

interface PhoneNumberInputProps {
  value: string;
  onChange: (value: string) => void;
  label?: string;
  required?: boolean;
  error?: boolean;
  errorMessage?: string;
  disabled?: boolean;
}

const PhoneNumberInput: React.FC<PhoneNumberInputProps> = ({
  value,
  onChange,
  label = "Mobile Number",
  required = false,
  error = false,
  errorMessage = "Field is required",
  disabled = false,
}) => {
  const baseBorder = error
    ? "!border-red-600 focus:!border-red-600"
    : "!border-gray-400 focus:!border-gray-600";

  const baseBg = disabled ? "!bg-gray-200 !cursor-not-allowed" : "!bg-white";

  return (
    <div className="phoneNumberContainer mb-4">
      <label className="textInputLabel">
        {label}
        {required && <span className="textInputLabelRequired">*</span>}
      </label>

      <PhoneInput
        country={"in"}
        enableSearch
        value={value}
        onChange={onChange}
        inputProps={{
          required,
          autoComplete: "off",
          disabled,
        }}
        containerClass="!w-full !rounded-full"
        inputClass={`!w-full !py-2 !pl-14 !pr-4 !h-10 !rounded-full !text-sm ${baseBorder} ${baseBg}`}
        buttonClass={`!rounded-l-full !px-1 ${baseBorder} ${baseBg}`}
        dropdownClass="!rounded-md"
        disabled={disabled}
      />

      {error && <p className="textInputErrorMessage">{errorMessage}</p>}
    </div>
  );
};

export default PhoneNumberInput;